export const BODY_MARKER_ATTRIBUTE = "data-smar-theme-key";
